import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

export default function ProfileDetailsGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container spacing={0}>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[0]}</Grid>
        <Grid size={6}>{items[1]}</Grid>
      </Grid>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[2]}</Grid>
      </Grid>
      <Grid size={4}>{items[3]}</Grid>
      <Grid container size={8}>
        <Grid size={12}>{items[4]}</Grid>
        <Grid size={12}>{items[5]}</Grid>
      </Grid>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[6]}</Grid>
        <Grid size={6}>{items[7]}</Grid>
      </Grid>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[8]}</Grid>
        <Grid size={6}>{items[9]}</Grid>
      </Grid>
      <Grid size={12}>{items[10]}</Grid>
    </Grid>
  );
}

ProfileDetailsGrid.propTypes = {
  children: PropTypes.node,
};
